export const GALLERY_CAROUSEL_OPTIONS = imgIndex => ({
  start: imgIndex,
  perPage: 3,
  perMove: 1,
  gap: '1em',
  width: '100%',
  type: 'loop',
  height: '400px',
  classes: {
    prev: 'splide__arrow--prev gallery-prev',
    next: 'splide__arrow--next gallery-next',
    pagination: 'splide__pagination gallery-pagination',
  },
  breakpoints: {
    1020: {
      perPage: 1,
      arrows: false,
    },
  },
});

export const GALLERY_AUTOSCROLL_CAROUSEL_OPTIONS = page => ({
  start: { page },
  type: 'loop',
  perPage: 5,
  width: '100%',
  arrows: false,
  focus: 'center',
  gap: '1em',
  breakpoints: {
    1240: {
      perPage: 4,
    },
    1020: {
      perPage: 3,
    },
    720: {
      perPage: 2,
    },
    490: {
      perPage: 1,
    },
  },
  autoScroll: {
    pauseOnHover: false,
    pauseOnFocus: false,
    rewind: false,
    speed: 0.5,
  },
});

// todo: page should be a number and we can not have start: { page }, but start: page
// todo: look at the documentation and see if we can remove the start: { page } and just use start: page
//response: I think we need to look into a new implementation of the carousel here to match what we need on the new marketing blocks
export const SERVICES_CAROUSEL_OPTIONS = (page: number) => ({
  start: page,
  type: 'loop',
  perPage: 3,
  gap: '1em',
  width: 'auto',
  height: 'auto',
  classes: {
    prev: 'splide__arrow--prev list-prev',
    next: 'splide__arrow--next list-next',
  },
  breakpoints: {
    960: {
      perPage: 2,
    },
    846: {
      destroy: true,
    },
  },
  pagination: false,
});

export const MARKETING_SERVICES_CAROUSEL_OPTIONS = (page: number) => ({
  start: page,
  type: 'loop',
  perPage: 3,
  gap: '1em',
  width: 'auto',
  height: 'auto',
  classes: {
    prev: 'splide__arrow--prev list-prev',
    next: 'splide__arrow--next list-next',
  },
  breakpoints: {
    1024: {
      perPage: 2,
    },
    846: {
      perPage: 1,
    },
  },
  pagination: true,
});
